import { render, staticRenderFns } from "./plantilla.vue?vue&type=template&id=20dc78b3"
import script from "./plantilla.vue?vue&type=script&lang=js"
export * from "./plantilla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports